import { render, staticRenderFns } from "./LayoutFrontTopbar.vue?vue&type=template&id=156d3a66&scoped=true"
import script from "./LayoutFrontTopbar.vue?vue&type=script&lang=js"
export * from "./LayoutFrontTopbar.vue?vue&type=script&lang=js"
import style0 from "./LayoutFrontTopbar.vue?vue&type=style&index=0&id=156d3a66&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156d3a66",
  null
  
)

export default component.exports